/**
 * Created by Stefen Suhat on 5/22/2017.
 */

const primary = { main: '#F6404F' };
const green = '#2AD586';
const blue = '#027EF2';
const secondary = { main: blue, contrastText: '#FFF' };
const error = { main: '#F44336' };
// const blue= '#5E50F9';
const indigo = '#6610F2';
const purple = '#6A008A';
const pink = '#E91E63';
const red = '#F96868';
const orange = '#F2A654';
const yellow = '#F6E84E';
// const green= '#46c35f';
const teal = '#58D8A3';
const cyan = '#57C7D4';
const gray = '#6C757D';
const dark = '#001529';

export {
    primary,
    secondary,
    green,
    blue,
    error,
    indigo,
    pink,
    red,
    orange,
    teal,
    cyan,
    gray,
    yellow,
    purple,
    dark,
};
